import { v7 as uuidv7 } from 'uuid';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { CancellationReasonCode } from '../api';

interface CancelApplicationFlowState {
  flowId: string | null;
  reason: CancellationReasonCode | null;
  submitAttempts: number;
  startNewFlow: () => void;
  selectReason: (reason: CancellationReasonCode) => void;
  recordSubmitAttempt: () => number;
}

export const useCancelApplicationFlowStore = create<CancelApplicationFlowState>()(
  devtools(
    (set, get) => ({
      flowId: null,
      reason: null,
      submitAttempts: 0,
      startNewFlow: () => set({ flowId: uuidv7(), reason: null, submitAttempts: 0 }),
      selectReason: (reason) => set({ reason }),
      recordSubmitAttempt: () => {
        const submitAttempts = get().submitAttempts + 1;
        set({ submitAttempts });
        return submitAttempts;
      },
    }),
    { name: 'cancel-application-flow-store' },
  ),
);
